import { Badge } from "@/components/common";
import HeroBusiness from "@/components/common/HeroBusiness";
import PageTitleBox from "@/components/common/PageTitleBox";
import Container from "@/components/layout/Container";
import { Link } from "react-router-dom";

const BusinessAlimtalk = () => {
  return (
    <Container>
      <HeroBusiness title="비즈니스를 완성하는" />

      <section id="main-content" className="py-[70px]">
        <PageTitleBox
          badge="알림톡/브랜드톡"
          title={
            <>
              고객이 기다리는 정보성 메시지부터
              <br />
              마케팅까지 하나로,
              <strong className="text-[#1976D2]"> 알림톡 / 브랜드톡</strong>
            </>
          }
          subtitle={
            <>
              카카오톡 기반의 알림톡·브랜드톡 서비스를 통해
              <br />
              시의적절한 정보 전달과 마케팅을 동시에 제공합니다.
            </>
          }
        />

        {/* 알림톡/브랜드톡 상단 이미지 섹션 */}
        <section className="mb-20">
          <div className="grid items-start grid-cols-1 gap-8 md:grid-cols-2">
            <div className="flex flex-col items-center justify-center">
              <span className="inline-block px-5 py-2 bg-blue rounded-full text-white text-[1.4rem] font-semibold mb-6">
                알림톡
              </span>
              <img
                src="/img/alimtalk/alimtalk_top_01.png"
                alt="알림톡 예시"
                className="max-w-full w-auto max-h-[500px] object-contain"
              />
            </div>
            <div className="flex flex-col items-center justify-center">
              <span className="inline-block px-5 py-2 bg-blue rounded-full text-white text-[1.4rem] font-semibold mb-6">
                브랜드톡
              </span>
              <img
                src="/img/alimtalk/alimtalk_top_02.png"
                alt="브랜드톡 예시"
                className="max-w-full w-auto max-h-[500px] object-contain"
              />
            </div>
          </div>
        </section>

        {/* 알림톡 설명 섹션 */}
        <section className="py-16 mb-12">
          <div className="mb-12">
            <Badge className="bg-navy" color="white">
              알림톡
            </Badge>
          </div>
          <h3 className="text-[3.2rem] font-bold text-black mb-8 leading-[1.3]">
            번호만 있다면 OK ! 친구 추가 없이 전달되는
            <br />
            가장 확실한 신뢰 '알림톡'
          </h3>

          {/* 3단계 플로우 다이어그램 */}
          <div className="w-full my-24">
            <div className="relative max-w-[1000px] mx-auto px-6">
              <div className="relative z-10 flex flex-col items-center justify-between gap-8 md:flex-row">
                {[
                  { label: "법인등록", image: "/img/alimtalk/alimtalk-01.png" },
                  { label: "채널 개설", image: "/img/alimtalk/alimtalk-02.png" },
                  { label: "템플릿 설정 후 발송", image: "/img/alimtalk/alimtalk-03.png" },
                ].map((step, idx) => (
                  <div key={idx} className="flex flex-col items-center flex-1 text-center">
                    <div className="w-full max-w-[320px] mb-4 bg-white rounded-xl overflow-hidden shadow-md">
                      <img
                        src={step.image}
                        alt={step.label}
                        className="object-cover w-full h-auto"
                      />
                    </div>
                    <div className="w-[48px] h-[48px] rounded-full bg-navy text-white flex items-center justify-center text-[1.6rem] font-bold mb-2 border-4 border-white shadow-md">
                      {idx + 1}
                    </div>
                    <span className="text-[1.5rem] text-gray-6 font-medium">{step.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <p className="text-[1.8rem] text-center leading-[1.8] text-gray-6 max-w-[900px] mx-auto">
            고객의 전화번호를 기반으로 발송하는 카카오톡 기반의{" "}
            <strong className="text-navy">정보성 메시지 서비스</strong>입니다.
            <br />
            친구 추가 없이도 주문, 결제, 예약, 안내, 학원 알림 등 정보성 메시지를 쉽고 빠르게 발송이
            가능합니다.
          </p>
        </section>

        {/* 브랜드톡 섹션 */}
        <section className="py-16 bg-[#f8f9ff] rounded-3xl mb-12">
          <div className="px-8 lg:px-12">
            <div className="mb-12">
              <Badge className="bg-navy" color="white">
                브랜드톡
              </Badge>
            </div>
            <div className="grid items-center grid-cols-1 gap-12 lg:grid-cols-2">
              <div>
                <h2 className="text-[3.2rem] font-bold text-gray-900 mb-8 leading-[1.2]">
                  이미지부터 영상, 버튼까지 자유롭게!
                  <br />
                  API 연동으로 더 완벽해지는
                  <br />
                  고도화 메시지 '브랜드톡'
                </h2>

                {/* 브랜드톡 기능 아이콘들 */}
                <div className="flex gap-4 my-8">
                  {[
                    { icon: "description", label: "텍스트" },
                    { icon: "image", label: "이미지" },
                    { icon: "play_arrow", label: "동영상" },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="flex flex-col items-center gap-2 px-8 py-6 bg-white border rounded-md border-gray-2"
                    >
                      <span className="material-icons-round text-[3.2rem] text-gray-6">
                        {item.icon}
                      </span>
                      <span className="text-[1.4rem] text-gray-7 font-medium">{item.label}</span>
                    </div>
                  ))}
                </div>

                <p className="text-[1.6rem] leading-[1.8] text-gray-6">
                  카카오톡 채널을 보유한 고객을 대상으로 발송되는{" "}
                  <strong className="text-navy">정보/마케팅형 고도화 메시지</strong>입니다.
                  <br />
                  텍스트, 이미지, 동영상 등 다양한 포맷과 추가 기능을 활용할 수 있습니다.
                </p>
              </div>
              <div className="flex flex-col items-center">
                <img
                  src="/img/alimtalk/brandtalk_01.png"
                  alt="브랜드톡 고객 예시"
                  className="w-full max-w-[360px] h-auto rounded-2xl shadow-xl"
                />
                <div className="flex items-center gap-2 mt-4 text-[1.4rem] text-gray-5">
                  <span className="material-icons-round text-navy text-[1.6rem]">check_circle</span>
                  브랜드톡을 받는 고객의 예
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 text-center">
          <h3 className="text-[2.8rem] font-bold mb-4">
            고객과 소통하는 가장 친근한 방법
            <br />
            알림톡/브랜드톡
          </h3>
          <Link
            to="/service/submit"
            className="inline-flex items-center gap-2 mt-6 px-8 py-4 bg-navy text-white rounded-sm text-[1.6rem] font-medium hover:bg-navy/90 transition-colors"
          >
            서비스 신청하기
          </Link>
        </section>
      </section>
    </Container>
  );
};

export default BusinessAlimtalk;
